// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDisconnectOutlinedSvg from "@fishx/icons-svg/es/asn/PDisconnectOutlined";
import FishxIcon from '../components/FishxIcon';

var PDisconnectOutlined = function PDisconnectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDisconnectOutlinedSvg
  }));
};

PDisconnectOutlined.displayName = 'PDisconnectOutlined';
export default React.forwardRef(PDisconnectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDisconnectOutlined.js
// module id = 3329
// module chunks = 0